/**
 * StartupCredit.jsx — Iter 50, reworked in Iter 70.
 *
 * Founder Credit. No longer a marketplace: the product grid was removed and the
 * landing page is now the credit application itself (Apply for Credit +
 * Engagements). MarketplaceTabsShell branches on category — see the note there.
 */
import React from 'react';
import MarketplaceTabsShell from '../../../components/MarketplaceTabsShell';

const StartupCredit = () => <MarketplaceTabsShell category="credit" />;
export default StartupCredit;
